import { createElement } from 'react'
import ReactMarkdown from 'react-markdown'
import { remarkHeadingIds, remarkOutline } from '#lib/markdown-headings.js'

function markdownElement(element, className) {
  return function MarkdownElement(props) {
    const attributes = { ...props }
    delete attributes.node
    return createElement(element, { ...attributes, className })
  }
}

const components = {
  a: markdownElement(
    'a',
    'font-medium text-foreground underline decoration-border underline-offset-4 hover:decoration-foreground',
  ),
  blockquote: markdownElement(
    'blockquote',
    'my-6 border-l-2 border-border pl-5 text-muted-foreground',
  ),
  code: markdownElement(
    'code',
    'rounded-sm bg-muted px-1.5 py-0.5 font-mono text-[0.9em] text-foreground',
  ),
  h2: markdownElement(
    'h2',
    'mt-12 scroll-mt-24 text-2xl font-semibold tracking-tight text-foreground first:mt-0',
  ),
  h3: markdownElement(
    'h3',
    'mt-8 scroll-mt-24 text-lg font-semibold text-foreground',
  ),
  img: markdownElement(
    'img',
    'my-8 w-full rounded-lg border border-border bg-muted shadow-sm',
  ),
  li: markdownElement('li', 'pl-1'),
  ol: markdownElement('ol', 'my-5 list-decimal space-y-2 pl-6'),
  p: markdownElement('p', 'my-5 leading-7'),
  pre: markdownElement(
    'pre',
    'my-6 overflow-x-auto rounded-lg border border-border bg-muted p-4',
  ),
  strong: markdownElement('strong', 'font-semibold text-foreground'),
  ul: markdownElement('ul', 'my-5 list-disc space-y-2 pl-6'),
}

export function Markdown({ children, headingAnchors = false }) {
  return (
    <ReactMarkdown
      components={components}
      remarkPlugins={headingAnchors ? [remarkHeadingIds] : []}
      skipHtml
    >
      {children}
    </ReactMarkdown>
  )
}

export function MarkdownOutline({ children }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkHeadingIds, remarkOutline]} skipHtml>
      {children}
    </ReactMarkdown>
  )
}
